import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Drawer, Grid, IconButton, Stack, Card, Typography, Badge, List, ListItem, Paper, CircularProgress, } from "@mui/material"
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ReactSelect from "react-select"
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { formatTimestampToWithoutTime, formatTimestampToDateView } from "utilities/common";
import { addDiscrepancyComment, assignInventoryManager, getDiscrepancyDetails, getDiscrepancyLogs, getInventoryManagers } from "../../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
// custom components
import MDButton from 'components/MDButton';
import { UploadPhoto } from "common/uploadPhoto";
import NoDataFound from "common/component/NoDataFound";

export default function DiscrepancyDetails({ open, TransitionComponent, handleClose, handleDiscrepancyList = () => { } }) {
  const dispatch = useDispatch()

  const { user } = useSelector(state => state.auth || {})

  const [details, setDetails] = useState({});
  const [logs, setLogs] = useState([]);
  const [value, setValue] = useState('tab-description');
  const [isLoading, setIsLoading] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [comment, setComment] = useState({});
  const [managers, setManagers] = useState([]);
  const [assignManagerDetails, setAssignManagerDetails] = useState({});

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange = (event) => {
    const { name, value } = event.target
    setAssignManagerDetails(prev => ({ ...prev, [name]: value }));
  };

  const handleDiscrepancyDetails = async () => {
    try {
      const response = await dispatch(getDiscrepancyDetails(open)).unwrap()
      if (response?.data) {
        setDetails(response?.data || {})
        const { assignedTo, assignmentStatus } = response?.data || {}
        setAssignManagerDetails({ assignedTo, status: assignmentStatus || "" })
      }
    } catch (error) {
      showToastMsg(error)
    }
  }

  const handleInventoryManagers = async () => {
    try {
      const response = await dispatch(getInventoryManagers({ limit: 1000 })).unwrap()
      if (response?.data) {
        setManagers(response?.data || {})
      }
    } catch (error) {
      showToastMsg(error)
    }
  }

  const handleDiscrepancyLogs = async () => {
    try {
      const response = await dispatch(getDiscrepancyLogs(open)).unwrap()
      if (response?.data) {
        setLogs(response?.data || {})
      }
    } catch (error) {
      showToastMsg(error)
    }
  }

  const handleCommentChange = (e) => {
    const { name, value } = e.target
    setComment({ ...comment, [name]: value })
  }

  const handleDeletePhoto = (image) => {
    setComment(prev => ({ ...prev, photos: prev.photos.filter((img) => img !== image) }))
  }

  const handleAddDiscrepancyComment = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await dispatch(addDiscrepancyComment({ ...comment, id: open })).unwrap()
      if (response?.success) {
        handleDiscrepancyDetails()
        setComment({})
      }
    } catch (error) {
      showToastMsg(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleAssignInventoryManager = async () => {
    if (!assignManagerDetails?.assignedTo || isAssigning) return;
    setIsAssigning(true);

    try {
      const request = { ...assignManagerDetails, updatedBy: user?.name, id: open, status: 'pending' }
      const response = await dispatch(assignInventoryManager({ ...request })).unwrap()
      if (response.success) {
        showToastMsg(response.message || "Success", "success")
        handleDiscrepancyList();
      }
    } catch (error) {
      showToastMsg(error)
    } finally {
      setIsAssigning(false)
    }
  }

  useEffect(() => {
    if (open) {
      handleDiscrepancyDetails()
      handleDiscrepancyLogs()
      handleInventoryManagers()
    } else {
      setAssignManagerDetails({})
    }
  }, [open]);

  return (
    <Drawer
      open={Boolean(open)}
      TransitionComponent={TransitionComponent}
      keepMounted
      maxWidth='xs'
      fullWidth
      className="cus-drawer discrepancy-stock-drawer"
      onClose={handleClose}
      anchor='right'
    >
      <Box p={1.25}>
        <Box className='d-flex align-item-center jc-s-btwn mb-3'>
          <Badge style={{ display: "flex", color: "#656575", padding: "3px 5px", justifyContent: "center", alignItems: "center", borderRadius: "4px", background: "#F2F3F7", fontSize: "12px", fontWeight: "500" }}>{details?.distributionType}</Badge>
          <IconButton onClick={handleClose} edge='end' size='small'>
            <CloseIcon fontSize='medium' />
          </IconButton>
        </Box>
        <Typography variant='h4' fontWeight='700' color="#2E2E3A" style={{ wordBreak: "break-word" }}>{details?.discrepancyType}</Typography>
      </Box>

      <Box p={{ xs: 1.25 }}>
        <TabContext value={value}>
          {/* Tabs */}
          <Box className="drawer-tabs">
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="Description" value="tab-description" />
              <Tab label="Activity Log" value="tab-activity-log" />
            </TabList>
          </Box>

          {/* Discrepancy details */}
          <TabPanel value="tab-description" className='px-0 pb-0'>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} md={6}>
                  <Typography variant='body2' fontWeight="medium" color="#656575" mb={1} className='text-12'>Status</Typography>
                  <ReactSelect
                    className='cus-react-select white-radius-field'
                    classNamePrefix="form-select"
                    name="status"
                    placeholder="Select"
                    options={[
                      { value: "pending", label: "Submit for Approval" }
                    ]}
                    value={
                      assignManagerDetails?.status
                        ? {
                          value: assignManagerDetails.status,
                          label: "Submit for Approval"
                        }
                        : null
                    }
                    onChange={option => {
                      handleChange({
                        target: {
                          name: "status",
                          value: option ? option.value : ""
                        }
                      });
                    }}
                    onBlur={handleAssignInventoryManager}
                    components={{ IndicatorSeparator: null }}
                  />
                </Grid> */}
              {details?.status === "rejected" || details?.status === "resolved" ?
                <Grid item xs={12} md={12}>
                  <ul className="w-100 d-flex flex-column" style={{ gap: "12px" }}>
                    <li className="w-100 d-flex align-item-center gap-1">
                      <Typography variant='body' fontWeight="normal" color="#656575"
                        className="d-flex align-item-center fs-x-small gap-1"
                        style={{ minWidth: "150px" }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                          <path fillRule="evenodd" clipRule="evenodd" d="M6.99967 6.33366C7.9662 6.33366 8.74967 5.55015 8.74967 4.58366C8.74967 3.61716 7.9662 2.83366 6.99967 2.83366C6.03315 2.83366 5.24967 3.61716 5.24967 4.58366C5.24967 5.55015 6.03315 6.33366 6.99967 6.33366ZM6.99967 7.50033C8.61049 7.50033 9.91634 6.19449 9.91634 4.58366C9.91634 2.97283 8.61049 1.66699 6.99967 1.66699C5.38885 1.66699 4.08301 2.97283 4.08301 4.58366C4.08301 6.19449 5.38885 7.50033 6.99967 7.50033Z" fill="#656575" />
                          <path fillRule="evenodd" clipRule="evenodd" d="M5.25 9.83366C3.96133 9.83366 2.91667 10.8784 2.91667 12.167V12.7503C2.91667 13.0725 2.6555 13.3337 2.33333 13.3337C2.01117 13.3337 1.75 13.0725 1.75 12.7503V12.167C1.75 10.234 3.317 8.66699 5.25 8.66699H8.75C10.683 8.66699 12.25 10.234 12.25 12.167V12.7503C12.25 13.0725 11.9888 13.3337 11.6667 13.3337C11.3445 13.3337 11.0833 13.0725 11.0833 12.7503V12.167C11.0833 10.8784 10.0386 9.83366 8.75 9.83366H5.25Z" fill="#656575" />
                        </svg>

                        <span className="fs-x-small">{details?.status === "resolved" ? "Approved By" : "Rejected By"}</span>
                      </Typography>
                      <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>
                        {managers.find(m => m._id === assignManagerDetails?.assignedTo)?.name}
                      </Typography>
                    </li>
                  </ul>
                </Grid>
                : details?.status ? <Grid item xs={12} md={12}>
                  <Typography variant='body2' fontWeight="medium" color="#656575" mb={1} className='text-12'>Assigned To</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <ReactSelect
                        className='cus-react-select white-radius-field'
                        classNamePrefix="form-select"
                        name="assignedTo"
                        placeholder="Select"
                        options={managers?.map(manager => ({ value: manager._id, label: manager.name }))}
                        value={
                          managers?.find(m => m._id === assignManagerDetails?.assignedTo)
                            ? {
                              value: assignManagerDetails.assignedTo,
                              label: managers.find(m => m._id === assignManagerDetails?.assignedTo)?.name
                            }
                            : null
                        }
                        onChange={option => handleChange({ target: { name: "assignedTo", value: option ? option.value : "" } })}
                        components={{ IndicatorSeparator: null }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MDButton
                        variant="contained"
                        sx={{ minWidth: '200px', background: "#2E2E3A !important", color: "#ffffff !important", fontSize: "14px", minHeight: "44px", padding: "7px 20px" }}
                        disabled={isAssigning || !assignManagerDetails?.assignedTo}
                        onClick={handleAssignInventoryManager}
                      >
                        {isAssigning ? <CircularProgress size={22} color="light" /> : "Submit for Approval"}
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
                  : null}

              {/* Basic details */}
              <Grid item xs={12} md={12}>
                <ul className="w-100 d-flex flex-column" style={{ gap: "12px" }}>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.99967 6.33366C7.9662 6.33366 8.74967 5.55015 8.74967 4.58366C8.74967 3.61716 7.9662 2.83366 6.99967 2.83366C6.03315 2.83366 5.24967 3.61716 5.24967 4.58366C5.24967 5.55015 6.03315 6.33366 6.99967 6.33366ZM6.99967 7.50033C8.61049 7.50033 9.91634 6.19449 9.91634 4.58366C9.91634 2.97283 8.61049 1.66699 6.99967 1.66699C5.38885 1.66699 4.08301 2.97283 4.08301 4.58366C4.08301 6.19449 5.38885 7.50033 6.99967 7.50033Z" fill="#656575" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.25 9.83366C3.96133 9.83366 2.91667 10.8784 2.91667 12.167V12.7503C2.91667 13.0725 2.6555 13.3337 2.33333 13.3337C2.01117 13.3337 1.75 13.0725 1.75 12.7503V12.167C1.75 10.234 3.317 8.66699 5.25 8.66699H8.75C10.683 8.66699 12.25 10.234 12.25 12.167V12.7503C12.25 13.0725 11.9888 13.3337 11.6667 13.3337C11.3445 13.3337 11.0833 13.0725 11.0833 12.7503V12.167C11.0833 10.8784 10.0386 9.83366 8.75 9.83366H5.25Z" fill="#656575" />
                      </svg>
                      <span className="fs-x-small">Reported By</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>{details?.createdBy}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path d="M2.46394 14H11.5351C12.486 14 13.2588 13.2272 13.2588 12.2763V3.68665C13.2588 2.73573 12.486 1.96295 11.5351 1.96295H10.8514V1.48147C10.8514 1.21665 10.6347 1 10.3698 1C10.105 1 9.88837 1.21665 9.88837 1.48147V1.96295H4.11062V1.48147C4.11062 1.21665 3.89393 1 3.62911 1C3.36429 1 3.14764 1.21665 3.14764 1.48147V1.96295H2.46394C1.51302 1.96295 0.740234 2.73573 0.740234 3.68665V12.2763C0.740234 13.2272 1.51302 14 2.46394 14ZM1.70322 3.68665C1.70322 3.26778 2.04507 2.92593 2.46394 2.92593H3.14764V3.4074C3.14764 3.67222 3.36429 3.88888 3.62911 3.88888C3.89393 3.88888 4.11058 3.67222 4.11058 3.4074V2.92593H9.88837V3.4074C9.88837 3.67222 10.105 3.88888 10.3698 3.88888C10.6347 3.88888 10.8513 3.67222 10.8513 3.4074V2.92593H11.535C11.9539 2.92593 12.2957 3.26778 12.2957 3.68665V5.0926H1.70322V3.68665ZM1.70322 6.05554H12.2958V12.2763C12.2958 12.6952 11.954 13.037 11.5351 13.037H2.46394C2.04507 13.037 1.70322 12.6952 1.70322 12.2763V6.05554Z" fill="#656575" />
                      </svg>
                      <span className="fs-x-small">Discrepancy Date</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>{formatTimestampToWithoutTime(details?.createdDate)}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.99967 6.33366C7.9662 6.33366 8.74967 5.55015 8.74967 4.58366C8.74967 3.61716 7.9662 2.83366 6.99967 2.83366C6.03315 2.83366 5.24967 3.61716 5.24967 4.58366C5.24967 5.55015 6.03315 6.33366 6.99967 6.33366ZM6.99967 7.50033C8.61049 7.50033 9.91634 6.19449 9.91634 4.58366C9.91634 2.97283 8.61049 1.66699 6.99967 1.66699C5.38885 1.66699 4.08301 2.97283 4.08301 4.58366C4.08301 6.19449 5.38885 7.50033 6.99967 7.50033Z" fill="#656575" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.25 9.83366C3.96133 9.83366 2.91667 10.8784 2.91667 12.167V12.7503C2.91667 13.0725 2.6555 13.3337 2.33333 13.3337C2.01117 13.3337 1.75 13.0725 1.75 12.7503V12.167C1.75 10.234 3.317 8.66699 5.25 8.66699H8.75C10.683 8.66699 12.25 10.234 12.25 12.167V12.7503C12.25 13.0725 11.9888 13.3337 11.6667 13.3337C11.3445 13.3337 11.0833 13.0725 11.0833 12.7503V12.167C11.0833 10.8784 10.0386 9.83366 8.75 9.83366H5.25Z" fill="#656575" />
                      </svg>
                      <span className="fs-x-small">Discrepancy Type</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>{details?.discrepancyType}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <g clipPath="url(#clip0_17427_40226)">
                          <path d="M12.0969 14.0625H9.12188C8.3125 14.0625 7.65625 13.4062 7.65625 12.5969V8.59375C7.65625 8.35312 7.85312 8.15625 8.09375 8.15625H12.0969C12.9062 8.15625 13.5625 8.8125 13.5625 9.62188V12.5969C13.5625 13.4062 12.9062 14.0625 12.0969 14.0625ZM8.53125 9.03125V12.5969C8.53125 12.925 8.79375 13.1875 9.12188 13.1875H12.0969C12.425 13.1875 12.6875 12.925 12.6875 12.5969V9.62188C12.6875 9.29375 12.425 9.03125 12.0969 9.03125H8.53125Z" fill="#656575" />
                          <path d="M4.87812 14.0625H1.90312C1.09375 14.0625 0.4375 13.4062 0.4375 12.5969V9.62188C0.4375 8.8125 1.09375 8.15625 1.90312 8.15625H5.90625C6.14687 8.15625 6.34375 8.35312 6.34375 8.59375V12.5969C6.34375 13.4062 5.6875 14.0625 4.87812 14.0625ZM1.90312 9.03125C1.575 9.03125 1.3125 9.29375 1.3125 9.62188V12.5969C1.3125 12.925 1.575 13.1875 1.90312 13.1875H4.87812C5.20625 13.1875 5.46875 12.925 5.46875 12.5969V9.03125H1.90312Z" fill="#656575" />
                          <path d="M12.0969 6.84375H8.09375C7.85312 6.84375 7.65625 6.64687 7.65625 6.40625V2.40312C7.65625 1.59375 8.3125 0.9375 9.12188 0.9375H12.0969C12.9062 0.9375 13.5625 1.59375 13.5625 2.40312V5.37812C13.5625 6.1875 12.9062 6.84375 12.0969 6.84375ZM8.53125 5.96875H12.0969C12.425 5.96875 12.6875 5.70625 12.6875 5.37812V2.40312C12.6875 2.075 12.425 1.8125 12.0969 1.8125H9.12188C8.79375 1.8125 8.53125 2.075 8.53125 2.40312V5.96875Z" fill="#656575" />
                          <path d="M5.90625 6.84375H1.90312C1.09375 6.84375 0.4375 6.1875 0.4375 5.37812V2.40312C0.4375 1.59375 1.09375 0.9375 1.90312 0.9375H4.87812C5.6875 0.9375 6.34375 1.59375 6.34375 2.40312V6.40625C6.34375 6.64687 6.14687 6.84375 5.90625 6.84375ZM1.90312 1.8125C1.575 1.8125 1.3125 2.075 1.3125 2.40312V5.37812C1.3125 5.70625 1.575 5.96875 1.90312 5.96875H5.46875V2.40312C5.46875 2.075 5.20625 1.8125 4.87812 1.8125H1.90312Z" fill="#656575" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17427_40226">
                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span className="fs-x-small">Category</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>{details?.type}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path d="M2.46394 14H11.5351C12.486 14 13.2588 13.2272 13.2588 12.2763V3.68665C13.2588 2.73573 12.486 1.96295 11.5351 1.96295H10.8514V1.48147C10.8514 1.21665 10.6347 1 10.3698 1C10.105 1 9.88837 1.21665 9.88837 1.48147V1.96295H4.11062V1.48147C4.11062 1.21665 3.89393 1 3.62911 1C3.36429 1 3.14764 1.21665 3.14764 1.48147V1.96295H2.46394C1.51302 1.96295 0.740234 2.73573 0.740234 3.68665V12.2763C0.740234 13.2272 1.51302 14 2.46394 14ZM1.70322 3.68665C1.70322 3.26778 2.04507 2.92593 2.46394 2.92593H3.14764V3.4074C3.14764 3.67222 3.36429 3.88888 3.62911 3.88888C3.89393 3.88888 4.11058 3.67222 4.11058 3.4074V2.92593H9.88837V3.4074C9.88837 3.67222 10.105 3.88888 10.3698 3.88888C10.6347 3.88888 10.8513 3.67222 10.8513 3.4074V2.92593H11.535C11.9539 2.92593 12.2957 3.26778 12.2957 3.68665V5.0926H1.70322V3.68665ZM1.70322 6.05554H12.2958V12.2763C12.2958 12.6952 11.954 13.037 11.5351 13.037H2.46394C2.04507 13.037 1.70322 12.6952 1.70322 12.2763V6.05554Z" fill="#656575" />
                      </svg>
                      <span className="fs-x-small">Due Date</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#FD4438" style={{ wordBreak: "break-word" }}>{details?.overdueLabel}</Typography>
                    {/* <Typography variant='body2' fontWeight="500" color="#FD4438">{formatTimestampToWithoutTime(details?.dueDate)} (Overdue)</Typography> */}
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body' fontWeight="normal" color="#656575" className="d-flex align-item-center fs-x-small gap-1" style={{ minWidth: "150px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <g clipPath="url(#clip0_17612_71984)">
                          <path d="M7.42437 7.24588V4.60617C7.91778 4.78116 8.27218 5.25236 8.27218 5.80499C8.27218 6.03909 8.46198 6.22891 8.69611 6.22891C8.93023 6.22891 9.12003 6.03912 9.12003 5.80499C9.12003 4.78139 8.39068 3.92502 7.42437 3.72806V3.12021C7.42437 2.88611 7.23457 2.69629 7.00044 2.69629C6.76634 2.69629 6.57652 2.88608 6.57652 3.12021V3.72806C5.61023 3.92499 4.88086 4.78137 4.88086 5.80499C4.88086 6.77232 5.73942 7.30626 6.57652 7.75542V10.3951C6.08311 10.2201 5.7287 9.74894 5.7287 9.19631C5.7287 8.96221 5.53891 8.77239 5.30478 8.77239C5.07065 8.77239 4.88086 8.96219 4.88086 9.19631C4.88086 10.2199 5.61021 11.0763 6.57652 11.2732V11.8811C6.57652 12.1152 6.76632 12.305 7.00044 12.305C7.23454 12.305 7.42437 12.1152 7.42437 11.8811V11.2732C8.39066 11.0763 9.12003 10.2199 9.12003 9.19631C9.12 8.22896 8.26144 7.69504 7.42437 7.24588ZM6.57652 6.78433C6.09298 6.49701 5.7287 6.19349 5.7287 5.80502C5.7287 5.25236 6.08313 4.78119 6.57652 4.6062V6.78433ZM7.42437 10.3951V8.21697C7.9079 8.50429 8.27218 8.80781 8.27218 9.19629C8.27218 9.74894 7.91776 10.2201 7.42437 10.3951Z" fill="#656575" stroke="#656575" strokeWidth="0.2" />
                          <path d="M7 1C3.41591 1 0.5 3.91591 0.5 7.5C0.5 11.0841 3.41591 14 7 14C10.5841 14 13.5 11.0841 13.5 7.5C13.5 3.91591 10.5841 1 7 1ZM7 13.1522C3.8834 13.1522 1.34782 10.6166 1.34782 7.5C1.34782 4.38338 3.8834 1.84782 7 1.84782C10.1166 1.84782 12.6522 4.3834 12.6522 7.5C12.6522 10.6166 10.1166 13.1522 7 13.1522Z" fill="#656575" stroke="#656575" strokeWidth="0.2" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17612_71984">
                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span className="fs-x-small">Amount</span>
                    </Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>${details?.amount?.toLocaleString()}</Typography>
                  </li>
                </ul>
              </Grid>

              <Grid item xs={12}>
                <hr className='my-1' style={{ borderTop: "1px solid #D0D0DA", borderBottom: "none", borderLeft: "none", borderRight: "none" }} />
              </Grid>

              {/* Product details */}
              {details?.product && <Grid item xs={12} md={12}>
                <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={2}>Product Details</Typography>
                <Box className="flex-1">
                  <img src={details?.product?.assets?.thumbURL || details?.product?.assets?.origURL} style={{ width: "100px", height: "100px", objectFit: "cover", background: "#F1F1F1", borderRadius: "4px", overflow: "hidden", border: "none" }} />
                </Box>
                <ul className="w-100 d-grid mt-2" style={{ gap: "12px", paddingBottom: "12px" }}>
                  <li className="w-100 d-flex gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" style={{ minWidth: "183px" }}>Product Name</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" style={{ wordBreak: "break-word" }}>{details?.product?.name || "-"}</Typography>
                  </li>
                </ul>
                <ul className="w-100 d-grid grid-columns-two pb-2" style={{ gap: "12px" }}>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Value</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>${details?.product?.price?.toLocaleString() || "-"}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Brand</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.product?.brand?.name || "-"}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Sub Category</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.product?.category?.name || "-"}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">From Box</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.box?.name || "-"}</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Weight</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.product?.weight || 0}g</Typography>
                  </li>
                  <li className="w-100 d-flex align-item-center gap-1">
                    <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Batch</Typography>
                    <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1">
                      {details?.product?.batch?.map((batch, idx) => (
                        <span key={batch?.batchNo + idx} style={{ wordBreak: "break-word" }}>
                          {batch?.sku} (Qty {batch?.qty}){idx < details?.product?.batch?.length - 1 ? ',' : null} <br />
                        </span>
                      ))}
                    </Typography>
                  </li>
                </ul>
              </Grid>}

              {/* Discrepancy note and photos */}
              {(details?.note || details?.photos?.length > 0) && <Grid item xs={12} md={12}>
                <Card sx={{ p: 2, borderRadius: 2.5, boxShadow: 'none', background: '#F2F3F7' }}>
                  <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={1}>Notes</Typography>
                  <Typography variant='body2' fontWeight="normal" color="#656575" style={{ wordBreak: "break-word" }}>{details?.note}</Typography>
                  <Box display="flex" alignItems="start" flexWrap="wrap" gap={1} style={{ padding: "12px 0 16px" }}>
                    {details?.photos?.map(photo => (
                      <Box key={photo} style={{ width: "80px", height: "80px", borderRadius: "12px", background: "#F1F1F1", overflow: "hidden" }}>
                        <img src={photo} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      </Box>
                    ))}
                  </Box>
                </Card>
              </Grid>}

              {/* Add comment */}
              <Grid item xs={12} md={12}>
                <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={1}>Comments</Typography>
                <Card sx={{ borderRadius: 2.5, boxShadow: 'none', border: "1px solid #9A9AAF", overflow: "hidden" }}>
                  <textarea
                    placeholder='Add Note...'
                    style={{ border: "none", outline: "none", padding: "12px 12px 12px 20px", resize: "none" }}
                    name="comment"
                    value={comment?.comment || ""}
                    onChange={handleCommentChange}
                  />
                  <Stack direction='row' gap={1} alignItems='center' justifyContent="space-between" style={{ padding: "0 12px 12px 20px" }} className="upload-photo-drawer">
                    <UploadPhoto
                      photos={comment.photos}
                      handleDeletePhoto={handleDeletePhoto}
                      updatePhotos={photo => setComment(prev => ({ ...prev, photos: [...(prev.photos || []), photo] }))}
                      showLabel={false}
                    />
                    {/* <MDButton
                      variant="contained"
                      style={{ padding: "0", minWidth: "auto" }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 2.25H3C1.48438 2.25 0.25 3.4834 0.25 5V19C0.25 20.5166 1.48438 21.75 3 21.75H21C22.5156 21.75 23.75 20.5166 23.75 19V5C23.75 3.4834 22.5156 2.25 21 2.25ZM3 3.75H21C21.6895 3.75 22.25 4.31055 22.25 5V12.1885L17.5312 7.46973C17.2383 7.17676 16.7617 7.17676 16.4688 7.46973L8 15.9395L5.53125 13.4697C5.23828 13.1768 4.76172 13.1768 4.46875 13.4697L1.75 16.1885V5C1.75 4.31055 2.31055 3.75 3 3.75ZM21 20.25H3C2.31055 20.25 1.75 19.6895 1.75 19V18.3114L5 15.0605L7.46875 17.5303C7.76172 17.8232 8.23828 17.8232 8.53125 17.5303L17 9.06055L22.25 14.3115V19C22.25 19.6895 21.6895 20.25 21 20.25Z" fill="black" />
                        <path d="M7 11.75C8.51562 11.75 9.75 10.5166 9.75 9C9.75 7.4834 8.51562 6.25 7 6.25C5.48438 6.25 4.25 7.4834 4.25 9C4.25 10.5166 5.48438 11.75 7 11.75ZM7 7.75C7.68945 7.75 8.25 8.31055 8.25 9C8.25 9.68945 7.68945 10.25 7 10.25C6.31055 10.25 5.75 9.68945 5.75 9C5.75 8.31055 6.31055 7.75 7 7.75Z" fill="black" />
                      </svg>
                    </MDButton> */}
                    <MDButton
                      variant="contained"
                      sx={{ minWidth: '90px', background: "#2E2E3A !important", color: "#ffffff !important", fontSize: "14px", minHeight: "36px", padding: "7px 20px" }}
                      disabled={isLoading || !comment?.comment}
                      onClick={handleAddDiscrepancyComment}
                    >
                      {isLoading ? <CircularProgress size={22} color="light" /> : "Add"}
                    </MDButton>
                  </Stack>
                </Card>
              </Grid>

              {details?.comments?.length > 0 &&
                details?.comments?.map(comment => (
                  <Grid key={comment._id} item xs={12} md={12}>
                    <Card sx={{ p: 2, borderRadius: 2.5, boxShadow: 'none', border: "1px solid #D0D0DA", overflow: "hidden" }}>
                      <Typography variant='body2' fontWeight="500" color="#656575">{comment?.comment}</Typography>
                      <Box display="flex" alignItems="start" flexWrap="wrap" gap={1} style={{ padding: "12px 0 16px" }}>
                        {
                          comment?.photos?.map(photo => (
                            <Box key={photo} style={{ width: "80px", height: "80px", borderRadius: "12px", background: "#F1F1F1", overflow: "hidden" }}>
                              <img src={photo} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            </Box>
                          ))
                        }
                      </Box>
                      {/* <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='body2' fontWeight="600" lineHeight="normal" color="#2E2E3A">Sarah Chen</Typography>
                        <span style={{ lineHeight: "normal" }}>|</span>
                        <Typography variant='body2' fontWeight="500" lineHeight="normal" color="#2E2E3A">June 24, 2025</Typography>
                      </Box> */}
                    </Card>
                  </Grid>
                ))}

            </Grid>
          </TabPanel>

          {/* Activity logs */}
          <TabPanel value="tab-activity-log" className='px-0 pb-0'>
            <List sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
              {logs?.length > 0 ?
                logs?.map((log, i) => (
                  <ListItem key={i}>
                    <Paper sx={{ p: 2.5, width: "100%", bgcolor: "#F5F5FF", borderRadius: "0.75rem", boxShadow: "none" }} elevation={0}>
                      <Typography variant="h6" fontWeight="500" color="#2E2E3A" mb={1}>{log?.action}</Typography>
                      {/* <Typography variant="h6" fontWeight="500" color="#2E2E3A" mb={1}>Sarah Chen has changed the status from <span style={{ fontWeight: "600" }}>&apos;Open&apos; to &apos;Pending&apos;</span>.</Typography> */}
                      <Typography variant="body2" fontWeight="600" fontSize="12px" color="#656575" style={{ wordBreak: "break-word" }}>{formatTimestampToDateView(log?.updatedAt)}</Typography>
                    </Paper>
                  </ListItem>
                ))
                : <NoDataFound />
              }
            </List>
          </TabPanel>
        </TabContext>
      </Box>
    </Drawer >
  )
}
